export interface ArtistProfileFilterType {
  option: ArtistProfileFilterOption
}

export interface ArtistProfileFilterOption {
  label: string
  value: server.dto.IsArtistTypeFilterOptions
}

export const DefaultArtistProfileFilter: server.dto.IsArtistTypeFilterOptions =
  "notSet";

export const ArtistProfileOptions: ArtistProfileFilterOption[] = [
  {
    label: RESX.Artist.OnlyActiveArtists,
    value: "onlyActive"
  },
  {
    label: RESX.Artist.NoLongerActive,
    value: "onlyNoLongerActive"
  }
];

export const getOption = (value: server.dto.IsArtistTypeFilterOptions) => {
  return (
    ArtistProfileOptions.find((opt) => opt.value === value) ?? {
      label: RESX.Artist.OnlyActiveArtists,
      value: "notSet"
    }
  );
};

export const initialArtistProfileFilter: ArtistProfileFilterType = {
  option: getOption(DefaultArtistProfileFilter)
};
